import { ModuleRequestError, describeModuleError } from '@wit-support/admin-client-core';
import { notConfiguredText } from '@wit-support/ui';
import { CONTRACT_MISMATCH } from './api.js';
export const ADS_OFF_TEXT = 'Раздел рекламы не подключён или временно недоступен.';
export const UNAVAILABLE_TEXT = 'Сервис рекламы недоступен, попробуйте позже';
export const FORBIDDEN_READ_TEXT = 'Раздел «Реклама» недоступен вашей роли.';
export const FORBIDDEN_WRITE_TEXT = 'Это действие недоступно вашей роли.';
export const CAMPAIGNS_OFF_TEXT = 'Управление кампаниями выключено на сервере рекламы.';
/** Ответ auto-ads: этого нет / выключено — статус 404 `upstream_rejected` на списке. */
export const isUpstreamCode = (err, code) => err instanceof ModuleRequestError && err.upstreamCode === code;
/** Отказ «создана запуском конструктора» (409) с подробностями для плашки. */
export function managedByLaunchOf(err) {
    if (!(err instanceof ModuleRequestError) || err.upstreamCode !== 'managed-by-launch')
        return null;
    const launchId = err.details['launchId'];
    if (typeof launchId !== 'string')
        return null;
    const actions = err.details['availableActions'];
    const batchId = err.details['batchId'];
    return {
        launchId,
        batchId: typeof batchId === 'string' ? batchId : null,
        availableActions: Array.isArray(actions) ? actions.filter((a) => typeof a === 'string') : [],
    };
}
/**
 * Отказ запуска конструктора при паузе/включении его кампании
 * (`contracts-launch-ops.md`, 03.11): запуск занят, ждёт решения оператора или
 * не принимает включение. Фразу даёт сервер (русская); здесь — ссылка на запуск.
 */
export const LAUNCH_REFUSAL_CODES = [
    'managed-by-launch',
    'launch-busy',
    'launch-action-required',
    'verify-has-errors',
    'batch-cancelled',
    'start-passed',
    'reverify-required',
    'invalid-state',
    'not-applicable-to-launch',
];
export function launchRefusalOf(err) {
    if (!(err instanceof ModuleRequestError))
        return null;
    const code = err.upstreamCode;
    if (code === null || !LAUNCH_REFUSAL_CODES.includes(code))
        return null;
    const launchId = err.details['launchId'];
    if (typeof launchId !== 'string' || launchId === '')
        return null;
    return { launchId, text: err.serverMessage ?? 'Запуск этой кампании не принял действие.' };
}
/** Сообщение об итоге делегированного действия запуска — одна фраза на случай. */
export const LAUNCH_PENDING_TEXT = 'Запуск выполняет действие — статус обновится через минуту.';
export const AUTO_START_CANCELLED_TEXT = 'Автозапуск отменён.';
export function retryAfterSec(err) {
    if (!(err instanceof ModuleRequestError))
        return null;
    const n = Number(err.details['retryAfterSec']);
    return Number.isFinite(n) && n > 0 ? Math.ceil(n) : null;
}
/** Ошибку — словами: без кодов, JSON и id. */
export function describeCampaignsError(err, mode = 'read') {
    return describeModuleError(err, mode, {
        forbiddenRead: FORBIDDEN_READ_TEXT,
        forbiddenWrite: FORBIDDEN_WRITE_TEXT,
        notConfiguredCode: 'ads_not_configured',
        notConfiguredText: notConfiguredText('Сервис рекламы auto-ads', [
            'AUTO_ADS_API_BASE_URL',
            'AUTO_ADS_API_TOKEN',
        ]),
        unavailableText: UNAVAILABLE_TEXT,
        textOf: (e) => {
            if (e.serverMessage !== null)
                return e.serverMessage;
            return /^http_\d+$/.test(e.code) ? `HTTP ${e.status}` : 'неожиданный ответ сервера';
        },
        extra: (e) => {
            if (e.code === CONTRACT_MISMATCH)
                return 'Сервер рекламы прислал неожиданный ответ — повторите позже.';
            if (e.code === 'audit_unavailable')
                return e.serverMessage;
            if (e.code === 'invalid_confirm_token')
                return e.serverMessage;
            if (e.upstreamCode === 'META_RATE_LIMITED' || e.status === 429) {
                const sec = retryAfterSec(e);
                return sec !== null
                    ? `Meta ограничила запросы — повторите через ${sec} с`
                    : 'Meta ограничила запросы — повторите чуть позже';
            }
            return null;
        },
    });
}
//# sourceMappingURL=errors.js.map